import { Option } from "@storeblocks/select";
import { Context } from "Components/TextContext/TextContext";
import { Relation } from "Store/interfaces/Owner";

export const getRelationOptions = (getText: Context["getText"]): Option[] => [
  {
    label: getText("insuranceownerform.optionlabel.vehicleowner-default"),
    value: "",
  },
  {
    label: getText("insuranceownerform.optionlabel.vehicleowner-partner"),
    value: Relation.PARTNER,
  },
  {
    label: getText("insuranceownerform.optionlabel.vehicleowner-guardian"),
    value: Relation.GUARDIAN,
  },
  {
    label: getText("insuranceownerform.optionlabel.vehicleowner-other"),
    value: Relation.OTHER,
  },
];
